const patterns = {
  mobile: /^09\d{9}/,
  phone: /^0[1-8]\d{9}/,
  number: /^\d+$/,
  username: /^[a-zA-Z0-9_-]+$/g,
  email:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
};

export default patterns;
